/**
 * Email validation utility
 * @param email - The email string to validate
 * @returns boolean indicating if the email is valid
 */
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

/**
 * Phone number validation utility
 * @param phone - The phone number string to validate
 * @returns boolean indicating if the phone number is valid
 */
export const validatePhone = (phone: string): boolean => {
  // Remove spaces before testing
  const cleaned = phone.replace(/\s+/g, '').trim()
  const phoneRegex = /^\+?\d{7,15}$/
  return phoneRegex.test(cleaned)
}

/**
 * Check if a string is empty or only whitespace
 * @param value - The string to check
 * @returns boolean indicating if the string is empty
 */
export const isEmpty = (value: string): boolean => {
  return !value || !value.trim()
}

/**
 * Validate phone number with option to allow empty values
 * @param phone - The phone number string to validate
 * @param allowEmpty - Whether to consider empty phone numbers as valid
 * @returns boolean indicating if the phone number is valid
 */
export const validatePhoneNumber = (phone: string, allowEmpty: boolean = true): boolean => {
  if (allowEmpty && isEmpty(phone)) return true
  return validatePhone(phone)
}
